export const PAGE_TYPES = {
  HOMEPAGE: 'Homepage',
  PRODUCT_OVERVIEW: 'ProductOverview',
  PRODUCT_CATEGORY: 'ProductCategory',
  PRODUCT_DETAIL_PAGE: 'ProductDetailPage',
  BUSINESS_INFO: 'Business Info',
  GENERIC: 'Generic',
  SUSTAINABILITY: 'Sustainability',
  FAQ: 'FAQ',
  ARTICLE_TOP_VIEW: 'Article top view',
  ARTICLE: 'Article',
  DISTRIBUTOR: 'Distributor',
  CONTACT: 'Contact',
};
